import clsx from "clsx";
import * as React from "react";
import { SocialItemProps } from ".";

function SocialItem({ icon, label, href, target, ...props }: SocialItemProps) {
    const Container = href ? "a" : "div";
    const containerProps: any = props;

    if (href) {
        containerProps.href = href;
        containerProps.target = target;
    }

    return (
        <Container className="tmp-social__item" {...containerProps}>
            <div className="tmp-social__item__icon-container">
                {typeof icon === "string" ? (
                    <i className={clsx("tmp-social__item__icon", icon)} />
                ) : (
                    icon
                )}
            </div>
            <span className="tmp-social__item__label">{label}</span>
        </Container>
    );
}

export default SocialItem;
